import { createFileRoute } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';
import { MonitoringIndicatorsPage } from '@/features/devices/monitoring/MonitoringIndicatorsPage';

/** "Virtual ko'rsatkichlar" monitoring (584:16249). */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/monitoring/virtual')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: MonitoringVirtualRoute,
});

function MonitoringVirtualRoute() {
  const { tenant } = Route.useRouteContext();
  return <MonitoringIndicatorsPage tenant={tenant} kind="virtual" />;
}
